import React from 'react';
import PropTypes from 'prop-types';
import MakeModelAddModal from './make-model-add-modal';

const AddMakeModelModal = ({ isOpen, onClose, refetchData }) => {
  return (
    <MakeModelAddModal
      isOpen={isOpen}
      onClose={onClose}
      refetchData={refetchData}
    />
  );
};

AddMakeModelModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  refetchData: PropTypes.func.isRequired,
};

export default AddMakeModelModal;
